const concept = (() => {
  if (document.querySelector("body#pageConcept") !== null) {



    let sW = window.innerWidth;

    {
      let sec = document.querySelector('#jsSecMain');

      let logoBox = sec.querySelector('.js-logo-box');

      let accntBox0 = sec.querySelector('.js-accnt-box-0');

      let accntBox1 = sec.querySelector('.js-accnt-box-1');
      let accntBox2 = sec.querySelector('.js-accnt-box-2');
      let accntBox3 = sec.querySelector('.js-accnt-box-3');
      let accntBox4 = sec.querySelector('.js-accnt-box-4');

      setTimeout(() => {
        logoBox.classList.add('is-act')
      }, 1000);
      setTimeout(() => {
        accntBox0.classList.add('is-act')
      }, 2000);
      setTimeout(() => {
        accntBox1.classList.add('is-act')
        accntBox2.classList.add('is-act')
        accntBox3.classList.add('is-act')
        accntBox4.classList.add('is-act')
      }, 2500);



      gsap.to('#jsSecMain .js-logo-box', {
        opacity: 0,
        filter: 'blur(10px)',
        scrollTrigger: {
          trigger: '#jsSecCopy .js-bg-wrap',
          start: '0% 100%',
          end: '0% 0%',
          scrub: true,
          // markers: true
        }
      });



      if (sW < 768) {

        gsap.to('#jsSecMain .js-accnt-wrap', {
          opacity: 0,
          filter: 'blur(10px)',
          scrollTrigger: {
            trigger: '#jsSecCopy .js-bg-wrap',
            start: '0% 100%',
            end: '0% 50%',
            scrub: true,
            // markers: true
          }
        });

      } else {

        let to0 = gsap.to(accntBox0, {
          y: 500,
          ease: "none",
          scrollTrigger: {
            trigger: sec,
            start: '0% 0%',
            end: '0% -100%',
            scrub: 0,
            // markers: true
          }
        })
        let to1 = gsap.to(accntBox1, {
          y: 300,
          ease: "none",
          scrollTrigger: {
            trigger: sec,
            start: '0% 0%',
            end: '0% -100%',
            scrub: 0,
            // markers: true
          }
        })
        let to2 = gsap.to(accntBox2, {
          y: 350,
          ease: "none",
          scrollTrigger: {
            trigger: sec,
            start: '0% 0%',
            end: '0% -100%',
            scrub: 0,
            // markers: true
          }
        })
        let to3 = gsap.to(accntBox3, {
          y: 150,
          ease: "none",
          scrollTrigger: {
            trigger: sec,
            start: '0% 0%',
            end: '0% -100%',
            scrub: 0,
            // markers: true
          }
        })
        let to4 = gsap.to(accntBox4, {
          y: 100,
          ease: "none",
          scrollTrigger: {
            trigger: sec,
            start: '0% 0%',
            end: '0% -100%',
            scrub: 0,
            // markers: true
          }
        })

        let target = document.querySelector('body');
        let observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            to0.scrollTrigger.refresh()
            to1.scrollTrigger.refresh()
            to2.scrollTrigger.refresh()
            to3.scrollTrigger.refresh()
            to4.scrollTrigger.refresh()
            // console.log('comParallax refresh');
          });
        });
        observer.observe(target);

      }

    }



    {
      let sec = document.querySelector('#jsSecCncpt');

      let wraps = sec.querySelectorAll('.js-cncpt-wrap');


      gsap.to('#jsSecCncpt .js-cncpt-wrap-outer', {
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: '#jsSecCncpt .js-cncpt-wrap-outer',
          start: '0% 0%',
          endTrigger: '#jsSecCncpt',
          end: '100% 100%',
          pin: true,
          pinSpacing: false,
          // markers: true
        }
      });


      gsap.to('#jsSecCncpt .js-cncpt-wrap.num1', {
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: '#jsSecCncpt .js-trg-wrap.num1',
          start: '0% 0%',
          // endTrigger: '#jsSecCncpt',
          // end: '100% 100%',
          onEnter: () => wraps[0].classList.add('is-act'),
          onLeave: () => wraps[0].classList.remove('is-act'),
          onEnterBack: () => wraps[0].classList.add('is-act'),
          onLeaveBack: () => wraps[0].classList.remove('is-act'),
          // markers: true
        }
      });
      gsap.to('#jsSecCncpt .js-cncpt-wrap.num2', {
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: '#jsSecCncpt .js-trg-wrap.num2',
          start: '0% 0%',
          // endTrigger: '#jsSecCncpt',
          // end: '100% 100%',
          onEnter: () => wraps[1].classList.add('is-act'),
          onLeave: () => wraps[1].classList.remove('is-act'),
          onEnterBack: () => wraps[1].classList.add('is-act'),
          onLeaveBack: () => wraps[1].classList.remove('is-act'),
          // markers: true
        }
      });
      gsap.to('#jsSecCncpt .js-cncpt-wrap.num3', {
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: '#jsSecCncpt .js-trg-wrap.num3',
          start: '0% 0%',
          // endTrigger: '#jsSecCncpt',
          // end: '100% 100%',
          onEnter: () => wraps[2].classList.add('is-act'),
          onLeave: () => wraps[2].classList.remove('is-act'),
          onEnterBack: () => wraps[2].classList.add('is-act'),
          onLeaveBack: () => wraps[2].classList.remove('is-act'),
          // markers: true
        }
      });
      gsap.to('#jsSecCncpt .js-cncpt-wrap.num4', {
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: '#jsSecCncpt .js-trg-wrap.num4',
          start: '0% 0%',
          // endTrigger: '#jsSecCncpt',
          // end: '100% 100%',
          onEnter: () => wraps[3].classList.add('is-act'),
          // onLeave: () => wraps[3].classList.remove('is-act'),
          onEnterBack: () => wraps[3].classList.add('is-act'),
          onLeaveBack: () => wraps[3].classList.remove('is-act'),
          // markers: true
        }
      });
    }



  }
})()
export default concept;